export const NOTIFICATION_DURATION = 3000; // 3 секунды 